import React from 'react';
import { AlertCircle } from 'lucide-react';
import LanguageTranslator from '../LanguageTranslator';
import { useMarqueeAnimation } from '../../hooks/useMarqueeAnimation';

const CRISIS_RED = '#D7263D';

// Extracted crisis content component for reusability
const CrisisContent = () => (
  <>
    <AlertCircle className="inline mr-1" size={14} style={{ color: CRISIS_RED }} />
    <span className="font-semibold">CRISIS?</span>
    <span> Call 988 (Suicide & Crisis Lifeline)</span>
    <span className="mx-2">•</span>
    <span>Text HOME to 741741</span>
    <span className="mx-2">•</span>
    <span>Emergency: 911</span>
    <span className="mx-8" />
  </>
);

// Static display for reduced motion users
const StaticCrisisDisplay = () => (
  <div 
    className="whitespace-nowrap text-xs sm:text-sm px-3"
    style={{ color: CRISIS_RED }}
  >
    <CrisisContent />
  </div>
);

// Scrolling marquee display
const ScrollingCrisisDisplay = ({ scrollRef, contentRef }) => (
  <div 
    ref={scrollRef}
    className="flex whitespace-nowrap"
    style={{ willChange: 'transform' }}
  >
    <div 
      ref={contentRef}
      className="flex items-center text-xs sm:text-sm"
      style={{ color: CRISIS_RED }}
    >
      <CrisisContent />
      {/* Duplicate for seamless loop */}
      <CrisisContent />
    </div>
  </div>
);

export const CrisisBanner = () => {
  const { scrollRef, contentRef, prefersReducedMotion, pause, resume } = useMarqueeAnimation();

  return (
    <div 
      data-testid="crisis-banner" 
      className="fixed top-0 left-0 right-0 bg-white z-40 flex items-center justify-between overflow-hidden"
      style={{ 
        borderBottom: `1px solid ${CRISIS_RED}`,
        height: '36px'
      }}
      onMouseEnter={pause}
      onMouseLeave={resume}
    >
      {/* Scrolling content area */}
      <div className="flex-1 overflow-hidden relative h-full flex items-center">
        {prefersReducedMotion ? (
          <StaticCrisisDisplay />
        ) : (
          <ScrollingCrisisDisplay scrollRef={scrollRef} contentRef={contentRef} />
        )}
      </div>
      
      {/* Language translator - fixed on right */}
      <div className="flex-shrink-0 px-2 bg-white">
        <LanguageTranslator />
      </div>
    </div>
  );
};
